var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-results',{attrs:{"cta":{
    label: 'Take new task',
    class: `is-outlined ${_vm.loading ? 'is-loading' : ''}`
  },"icon":"hand-pointer","title":"No task selected","message":"Select a task or take a new one."},on:{"click":_vm.takeTask}})
}
var staticRenderFns = []

export { render, staticRenderFns }